import { TemplateId } from '@cibli/shared';

import type { RegisteredTemplate } from '../types';

import { createJsonResumeDisplay } from './Display';
import { jsonResumeDefaults, jsonResumeSchema } from './schema';

function createJsonResumeTemplate(
  id: TemplateId,
  name: string,
  themeId: string,
): RegisteredTemplate<typeof jsonResumeDefaults> {
  return {
    meta: { id, name },
    schema: jsonResumeSchema,
    defaults: jsonResumeDefaults,
    Display: createJsonResumeDisplay(themeId) as unknown as RegisteredTemplate<
      typeof jsonResumeDefaults
    >['Display'],
  };
}

export const jsonElegant = createJsonResumeTemplate(
  'json-elegant' as TemplateId,
  'Élégant',
  'elegant',
);
export const jsonFlat = createJsonResumeTemplate(
  'json-flat' as TemplateId,
  'Sobre',
  'flat',
);
export const jsonExecutiveSlate = createJsonResumeTemplate(
  'json-executive-slate' as TemplateId,
  'Executive',
  'executive-slate',
);
export const jsonModernClassic = createJsonResumeTemplate(
  'json-modern-classic' as TemplateId,
  'Modéré',
  'modern-classic',
);
export const jsonStackoverflow = createJsonResumeTemplate(
  'json-stackoverflow' as TemplateId,
  'Développeur',
  'stackoverflow',
);
